var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('my-tool-bar',{attrs:{"loading":_vm.loading,"mode":_vm.mode,"title":_vm.title},on:{"update:mode":function($event){_vm.mode=$event}}}),_c('m-layout',[_c('v-layout',[_c('v-container',{attrs:{"fill-height":""}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }